__turbopack_context__.v({
  "avatar": "FocusAreaCard-module-scss-module__sh1-iG__avatar",
  "avatars": "FocusAreaCard-module-scss-module__sh1-iG__avatars",
  "avatarsContainer": "FocusAreaCard-module-scss-module__sh1-iG__avatarsContainer",
  "card": "FocusAreaCard-module-scss-module__sh1-iG__card",
  "description": "FocusAreaCard-module-scss-module__sh1-iG__description",
  "footer": "FocusAreaCard-module-scss-module__sh1-iG__footer",
  "footerCount": "FocusAreaCard-module-scss-module__sh1-iG__footerCount",
  "footerInfo": "FocusAreaCard-module-scss-module__sh1-iG__footerInfo",
  "footerRow": "FocusAreaCard-module-scss-module__sh1-iG__footerRow",
  "footerText": "FocusAreaCard-module-scss-module__sh1-iG__footerText",
  "headerSection": "FocusAreaCard-module-scss-module__sh1-iG__headerSection",
  "seeMore": "FocusAreaCard-module-scss-module__sh1-iG__seeMore",
  "title": "FocusAreaCard-module-scss-module__sh1-iG__title",
});
